import SimpleBarReact from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';

export const SimpleBar = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className: string;
}) => {
  return <SimpleBarReact className={className}>{children}</SimpleBarReact>;
};
